export { default } from './Contact';

require('./contact.scss');
require('./__action/contact__action.scss');
require('./__separator/contact__separator.scss');
